import { useState , useEffect } from "react";
import { useHoneNewsVideosQuery } from "../../data/home-data";
import { formatPostTime, APP_URL } from "../../components/config/Common";
import { Link   } from "react-router-dom";
export default function YoutubeVideos() {
  const [selectedVideo, setSelectedVideo] = useState(null);
const [videoLoading, setVideoLoading] = useState(false);
  const { data: videos = [], isLoading } = useHoneNewsVideosQuery();
useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setSelectedVideo(null);
      setVideoLoading(false);
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, []);

  if (isLoading) {

     return (
    <section className="mx-auto max-w-screen-2xl mb-4 px-4 py-4">
      <div className="mb-6 h-8 w-48 animate-pulse rounded bg-gray-200" />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-2xl bg-white shadow"
          >
            <div className="h-48 animate-pulse bg-gray-200" />

            <div className="p-4">
              <div className="mb-3 h-4 w-full animate-pulse rounded bg-gray-200" />
              <div className="mb-3 h-4 w-3/4 animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-24 animate-pulse rounded bg-gray-200" />
            </div>
          </div>
        ))}
      </div>
    </section>
    );
  }

  return (
    <>
      <section className="mx-auto max-w-screen-2xl mb-2 px-4 py-4">
        <h2 className="mb-6 text-2xl text-gray-800">
          News Videos
        </h2>

        {/* 5 items per row on XL screens */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {videos.map((video) => (
            <div
              key={video.video_id}
              onClick={() =>{ setVideoLoading(true); setSelectedVideo(video.video_id) } }
              className="group cursor-pointer overflow-hidden rounded-2xl bg-white shadow transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              {/* Thumbnail */}
              <div className="relative">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="h-48 w-full object-cover"
                />

                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black/20 transition group-hover:bg-black/30" />

                {/* Play Button */}
<div className="absolute inset-0 flex items-center justify-center">
  <div className="flex h-12 w-16 items-center justify-center rounded-xl bg-black/70 backdrop-blur-sm shadow-lg transition-all duration-300 group-hover:scale-110 group-hover:bg-black/85">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="white"
      className="ml-1 h-7 w-7"
    >
      <path d="M8 5.14v14l11-7-11-7z" />
    </svg>
  </div>
</div>

                {/* Views */}
                {video.views && (
                  <div className="absolute bottom-3 right-3 rounded-full bg-black/80 px-3 py-1 text-xs text-white">
                    👁 {video.views}
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="line-clamp-2 min-h-[48px] font-semibold text-gray-900 group-hover:text-accent">
                  {video.title}
                </h3>

                <p className="mt-2 text-sm text-gray-500">
                  {video.published_at
                    ? new Intl.DateTimeFormat("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      }).format(
                        new Date(video.published_at.replace(" ", "T"))
                      )
                    : ""}
                </p>

              </div>
            </div>
          ))}
        </div>
        
        <div className="flex items-center justify-end my-3 text-sm text-accent hover:underline"><Link to={`${APP_URL}/news/news-videos`} target="_blank" className='text-white bg-accent hover:bg-secondary shadow-xs font-medium text-sm px-4 py-2.5 focus:outline-none'>More News Videos →</Link></div>
      </section>
       

      {/* Video Popup Modal */}
      {/* Premium Video Popup */}
{selectedVideo && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md p-4"
    onClick={() => {
      setSelectedVideo(null);
      setVideoLoading(false);
    }}
  >
    <div
      className="relative w-full max-w-md"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close Button */}
     <button
  onClick={() => {
    setSelectedVideo(null);
    setVideoLoading(false);
  }}
  className=" absolute top-14 right-3 z-50 rounded-full bg-black/70 p-2 text-white hover:bg-black"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
</button>

      {/* Video Container */}
      <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-black shadow-[0_20px_60px_rgba(0,0,0,0.7)]">
        
        {/* Loading Overlay */}
        {videoLoading && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-black">
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-white/20 border-t-white"></div>
            <p className="mt-4 text-sm text-white/70">
              Loading video...
            </p>
          </div>
        )}

        <iframe
          className="aspect-[9/16] w-full"
          src={`https://www.youtube.com/embed/${selectedVideo}?autoplay=1&rel=0`}
          title="YouTube Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          onLoad={() => setVideoLoading(false)}
        />
      </div>
    </div>
  </div>
)}
    </>
  );
}
